import axios from '@/utils/request'
import base from '../base'
import qs from 'qs'

export function gatewayList() {
    return axios.post(`${base.url}/auth/gateway/list`);
}
export function editgatewayList(data) {
    return axios.post(`${base.url}/auth/gateway/edit`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function addgatewayList(data) {
    return axios.post(`${base.url}/auth/gateway/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function companyBindingRoutes(data) {
    return axios.post(`${base.url}/auth/gateway/companyBindingRoutes`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function delgatewayList(id) {
    return axios.get(`${base.url}/auth/gateway/del?id=${id}`);
}
export function allgatewayList(id) {
    return axios.get(`${base.url}/auth/gateway/routesList?companyId=${id}`);
}

